import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { StorageService } from '../../../services/storage/storage.service';
import { RouteConstants } from '../../constants/routes.constants';
import { StorageKeys } from '../../enums/storage.enum';
import { faPlus, faBolt, faUserCircle, faHome, faSignature, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';import { EsignOverlayService } from '../../../services/esign-overlay/esign-overlay.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  standalone: false,
})
export class NavbarComponent implements OnInit, OnDestroy {
  userDetailsData: any;
  profilePic: any;
  credits: number = 0;
  userCircleIcon = faUserCircle;
  faBolt = faBolt;
  faPlus = faPlus;
  faSignOutAlt = faSignOutAlt;
  showDropdown = false;

  navLinks = [
    { label: 'Home', routerLink: RouteConstants.Dashboard, icon: faHome },
    { label: 'eSign', routerLink: RouteConstants.ESign, icon: faSignature },
  ];

  private userSub!: Subscription;
  private creditsSub!: Subscription;

  constructor(
    public authService: AuthService,
    private readonly router: Router,
    private readonly esignOverlayService: EsignOverlayService,
    private readonly storageService: StorageService,
  ) { }

  ngOnInit(): void {
    const stored = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    if (stored) {
      this.userDetailsData = stored;
    }
    this.userSub = this.authService.user$.subscribe(user => {
      if (user) {
        this.userDetailsData = user;
      }
    });
    this.creditsSub = this.authService.credits$.subscribe(val => {
      this.credits = val;
    });
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
    this.creditsSub?.unsubscribe();
  }

  get userInitials(): string {
    const name: string =
      this.userDetailsData?.[0]?.name ||
      this.userDetailsData?.name ||
      this.userDetailsData?.[0]?.emailAddress ||
      this.userDetailsData?.emailAddress ||
      '';
    return name ? name.charAt(0).toUpperCase() : 'U';
  }

  navigateToNewESign(): void {
    this.esignOverlayService.open();
  }

  navigateToWallet(): void {
    this.router.navigate([RouteConstants.Wallet]);
  }

    toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.storageService.clearLocalStorage();
        this.router.navigate([RouteConstants.Login]);
      },
      error: (error: any) => {
        console.error('Logout failed:', error);
        this.storageService.clearLocalStorage();
        this.router.navigate([RouteConstants.Login]);
      }
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const element = event.target as HTMLElement;
    const avatarWrapper = document.querySelector('.navbar__avatar-wrapper');
    if (avatarWrapper && !avatarWrapper.contains(element)) {
      this.showDropdown = false;
    }
  }
}
